import React from "react";
import { Col, Row, OverlayTrigger, Tooltip } from "react-bootstrap";
import {
  AiOutlineRobot,
  AiOutlineDatabase,
  AiOutlineCloudServer,
  AiOutlineApi
} from "react-icons/ai";
import { BiVector } from "react-icons/bi";
import { HiOutlineChip } from "react-icons/hi";
import { SiPytorch } from "react-icons/si";
import { AiOutlineExperiment, AiOutlineCheckCircle } from "react-icons/ai";

const calculateExperience = (startDate) => {
  const start = new Date(startDate);
  const now = new Date();
  const diffTime = Math.abs(now - start);
  const diffMonths = Math.ceil(diffTime / (1000 * 60 * 60 * 24 * 30));
  return diffMonths;
};

const AiMlIcon = ({ icon: Icon, name, category, startDate, description }) => {
  const experience = calculateExperience(startDate);

  return (
    <OverlayTrigger
      placement="top"
      overlay={
        <Tooltip id={`tooltip-${name}`} className="custom-tooltip">
          <div className="tooltip-content">
            <span className="tooltip-category">{category}</span>
            <strong className="tooltip-title">{name}</strong>
            <span className="experience-text">{experience} months</span>
            {description && <p style={{ fontSize: "0.85rem", margin: "5px 0 0 0" }}>{description}</p>}
          </div>
        </Tooltip>
      }
    >
      <Col xs={4} md={2} className="tech-icons">
        <Icon />
      </Col>
    </OverlayTrigger>
  );
};

function AiMlStack() {
  const aiMlStack = [
    {
      icon: SiPytorch,
      name: "PyTorch & Hugging Face",
      category: "ML Framework",
      startDate: "2026-06-01",
      description: "Training and evaluating models with PyTorch, Transformers, PEFT and TRL"
    },
    {
      icon: AiOutlineExperiment,
      name: "Fine-tuning (QLoRA, SFT, DPO)",
      category: "Model Training",
      startDate: "2026-06-01",
      description: "Parameter-efficient fine-tuning and preference optimization"
    },
    {
      icon: AiOutlineCheckCircle,
      name: "LLM Evaluation",
      category: "AI Safety",
      startDate: "2025-02-01",
      description: "Designing evaluations, RL environments and red-teaming tests"
    },
    {
      icon: AiOutlineDatabase,
      name: "RAG",
      category: "AI Technique",
      startDate: "2024-04-01",
      description: "Retrieval Augmented Generation for context-aware AI responses"
    },
    {
      icon: BiVector,
      name: "Vector Embeddings",
      category: "AI/ML",
      startDate: "2024-04-01",
      description: "Semantic search and similarity matching"
    },
    {
      icon: AiOutlineCloudServer,
      name: "Multi-LLM Architecture",
      category: "AI System Design",
      startDate: "2024-05-01",
      description: "Orchestrating multiple LLMs for optimal performance"
    },
    {
      icon: AiOutlineRobot,
      name: "AI Agents & MCP",
      category: "AI Agents",
      startDate: "2024-06-01",
      description: "Model Context Protocol for autonomous AI agents"
    },
    {
      icon: AiOutlineApi,
      name: "Deepgram",
      category: "Speech AI",
      startDate: "2024-07-01",
      description: "Real-time speech-to-text transcription"
    },
    {
      icon: HiOutlineChip,
      name: "LLM Integration",
      category: "AI Engineering",
      startDate: "2024-04-01",
      description: "OpenAI, Anthropic, and custom model integration"
    },
  ];

  return (
    <>
      <h1 className="project-heading" style={{ paddingTop: "40px" }}>
        AI/ML <strong className="purple">Expertise</strong>
      </h1>
      <p style={{ color: "white", fontSize: "1.1rem", marginBottom: "2rem", textAlign: "center" }}>
        Building, training and evaluating AI systems
      </p>
      <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
        {aiMlStack.map((tech, index) => (
          <AiMlIcon key={index} {...tech} />
        ))}
      </Row>
    </>
  );
}

export default AiMlStack;
